import { useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import RemoveCategoryModalContainer from 'modules/surveys/components/Questions/Categories/RemoveCategoryModalContainer'

const SurveyRemoveCategoryPage = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()
  const { question_group_config_id, question_category_id, id } = useParams()

  const onClose = () =>
    navigate(navigation.engagement.surveys.id.questions.fullPath({ id: String(id) }))

  return (
    <RemoveCategoryModalContainer
      formId={Number(id)}
      onClose={onClose}
      questionGroupConfigId={Number(question_group_config_id)}
      questionCategoryId={Number(question_category_id)}
    />
  )
}

export default SurveyRemoveCategoryPage
